export default __webpack_public_path__ + "static/media/merchandise.8308e960.svg";